import { useContext, useEffect, useState } from "react";
import { FixedAssetsInventoryDto } from "../../../../dtos/documents/FixedAssetsInventories/FixedAssetsInventoryDto";
import { FixedAssetsInventoryModel } from "../../../../models/Documents/FixedAssetsInventoryModel/FixedAssetsInventoryModel";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { FormProvider, useForm } from "react-hook-form";
import * as XLSX from "xlsx";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import FixedAssetsInventoriesDetailsSkeleton from "./FixedAssetsInventoriesDetailsSkeleton";
import { FIxedAssetsInventoriesDetailsMain } from "./FIxedAssetsInventoriesDetailsMain";
import { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { FixedAssetsInventoriesDetailFooter } from "./FixedAssetsInventoriesDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";

interface IProps {
  model: FixedAssetsInventoryDto | null;
  modelUpdatedEvent: (newModel: FixedAssetsInventoryDto) => void;
}

const FixedAssetsInventoriesDetails = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetsInventoryModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Inventory");

  useEffect(() => {
    console.log(model);
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("createdDate", model.createdDate);
      setValue("comment", model.comment);
      setValue("baseDocumentAtId", model.baseDocumentAtId);
      setValue("warehouseId", model.warehouseId);
      setValue("companyId", model.companyId);
    }
  }, [model]);

  const handleFormSubmit = async (action: DocumentSaveActionType, data: FixedAssetsInventoryModel) => {
    if (action === "save") {
      const newModel: FixedAssetsInventoryDto = { ...model, ...data };
      await saveHandler(newModel, action);
    } else if (action === "post") {
      const newModel: FixedAssetsInventoryDto = { ...model, ...data };
      await saveHandler(newModel, action);
      await postHandler(action);
    }
  };

  if (!model) {
    return (
      <>
        <FixedAssetsInventoriesDetailsSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.FixedAssetsInventories.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmit("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmit("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <FIxedAssetsInventoriesDetailsMain />
        </NFTabContainer>
      </div>
      <FixedAssetsInventoriesDetailFooter />
    </FormProvider>
  );
};

export default FixedAssetsInventoriesDetails;
